/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

const EditableField = forwardRef(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={classNames(Styles.mainContainer, className)}
    {...props}
  />
));

EditableField.propTypes = {
  className: PropTypes.string,
};

EditableField.defaultProps = {
  className: '',
};

export default EditableField;
